import type { CityConfig } from "@/pages/city-template/types";

export const woodburnConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Oregon Vital Records (Birth, Death, Marriage)", desc: "Request certified birth, death, and marriage certificates from Oregon Vital Records.", url: "https://www.oregon.gov/oha/PH/BirthDeathCertificates/Pages/index.aspx" },
    { icon: "ri-government-line", label: "Marion County Clerk Vital Records", desc: "Obtain vital records through the Marion County Clerk's office in Salem.", url: "https://www.co.marion.or.us/CO/" },
    { icon: "ri-global-line", label: "VitalChek — Order Vital Records Online", desc: "Official online ordering partner of Oregon Vital Records for certified certificates.", url: "https://www.vitalchek.com/" },
  ],
  city: "Woodburn",
  state: "Oregon",
  stateAbbr: "OR",
  slug: "woodburn",
  route: "/woodburn",
  title: "Emergency Passport Woodburn OR | Expedited Passport Marion County Oregon",
  metaDescription: "Emergency passport and expedited passport services in Woodburn, OR — as fast as 24 hours. Fast Passport Center serves Woodburn, north Marion County, Woodburn Premium Outlets visitors, Hubbard, Gervais, and the mid-Willamette Valley. Registered State Dept. courier. A+ BBB rated. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Woodburn, Oregon",
  heroSubtitle: "Outlet shopping trip to Canada turning into a Vancouver BC getaway? Family vacation to Mexico booked for winter break? Need a passport fast from Woodburn? Fast Passport Center helps Woodburn and north Marion County residents get expedited passports as fast as 24 hours — entirely remotely. The Seattle Passport Agency is 240 miles away, but we serve you without the drive.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Woodburn%20Oregon%20fertile%20agricultural%20landscape%20of%20the%20Willamette%20Valley%20with%20vast%20fields%20of%20nursery%20crops%20and%20vegetables%20under%20dramatic%20Pacific%20Northwest%20sky%2C%20the%20iconic%20Woodburn%20Premium%20Outlets%20shopping%20destination%20with%20Pacific%20Northwest%20architecture%2C%20Mount%20Hood%20volcano%20visible%20on%20the%20eastern%20horizon%2C%20rich%20volcanic%20soil%20farmland%20stretching%20toward%20the%20Cascade%20Range%2C%20golden%20hour%20agricultural%20scenery%2C%20photorealistic%20cinematic%20quality%2C%20no%20text%20no%20people&width=1800&height=700&seq=woodburn-or-hero-01&orientation=landscape",
  heroImageAlt: "Woodburn Oregon Willamette Valley agricultural landscape with Mount Hood on the horizon",
  geoPosition: "45.1437;-122.8553",
  geoPlacename: "Woodburn, Oregon",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "About 240 miles north — approximately 4 hours by car via I-5",
  },
  nearbyCitiesZips: [
    { name: "Woodburn", zips: "97071" },
    { name: "Hubbard", zips: "97032" },
    { name: "Gervais", zips: "97026" },
    { name: "Donald", zips: "97020" },
    { name: "Aurora", zips: "97002" },
    { name: "St. Paul", zips: "97137" },
    { name: "Mount Angel", zips: "97362" },
    { name: "Canby", zips: "97013" },
    { name: "Wilsonville", zips: "97070" },
    { name: "Silverton", zips: "97381" },
    { name: "Keizer", zips: "97303" },
    { name: "Salem", zips: "97301" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online from Woodburn", desc: "Complete your emergency or expedited passport order from anywhere in north Marion County — no road trip to Seattle required." },
    { icon: "ri-truck-line", title: "Overnight Shipping from Woodburn, Salem, or Wilsonville", desc: "Ship your documents from Woodburn, Salem, or Wilsonville FedEx Office — all support overnight delivery for expedited submissions." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application reviewed before submission — essential for north Marion County residents with diverse agricultural and retail trade travel needs." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Submission Access", desc: "We bypass the public appointment backlog with reserved Seattle Passport Agency slots — far faster than calling for an emergency appointment." },
  ],
  testimonials: [
    {
      name: "Maria G.",
      location: "Woodburn, OR",
      rating: 5,
      text: "We booked a family trip to Mexico for winter break and with three weeks to go, my husband's passport was expired. Fast Passport Center renewed it in 5 business days from Woodburn. The overnight shipping was so easy. Saved our family vacation.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "James R.",
      location: "Hubbard, OR",
      rating: 5,
      text: "I'm an agricultural equipment sales rep and got invited to a trade show in Germany with 4 weeks notice. My passport had expired. Fast Passport Center processed the renewal in 6 business days. I shipped from Woodburn and made the show.",
      service: "Expedited Passport Processing",
    },
    {
      name: "Elena V.",
      location: "Gervais, OR",
      rating: 5,
      text: "Needed a first-time passport for my son's school trip to Canada. Fast Passport Center walked us through the Woodburn Post Office acceptance visit and expedited everything from there. Passport arrived in 8 business days. Wonderful service for Marion County families.",
      service: "First-Time Child Passport Expedited",
    },
  ],
  facilities: [
    {
      id: "woodburn-post-main",
      name: "Woodburn Post Office",
      type: "USPS Passport Acceptance",
      address: "1900 N Pacific Hwy",
      city: "Woodburn",
      state: "OR",
      zip: "97071",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Woodburn — primary passport acceptance for Woodburn and north Marion County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance facility for Woodburn and north Marion County residents. Appointment required. Moderate availability — book 1–2 weeks ahead during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "salem-main-post",
      name: "Salem Main Post Office",
      type: "USPS Passport Acceptance",
      address: "1050 25th St SE",
      city: "Salem",
      state: "OR",
      zip: "97301",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Salem — about 15 miles south via I-5",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Larger facility with better appointment availability than Woodburn. Recommended when Woodburn is booked or for urgent situations.",
      icon: "ri-mail-line",
    },
    {
      id: "marion-county-clerk",
      name: "Marion County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "555 Court St NE, Suite 2130",
      city: "Salem",
      state: "OR",
      zip: "97301",
      phone: "(503) 588-5225",
      hours: "Mon–Fri 8:30am–5pm",
      distance: "Salem — Marion County Courthouse, about 16 miles south of Woodburn via I-5",
      website: "https://www.co.marion.or.us/CO/",
      websiteLabel: "Marion County Clerk",
      notes: "Marion County Clerk accepts passport applications at the Courthouse. Excellent appointment availability — often the best option for Woodburn residents willing to drive to Salem.",
      icon: "ri-government-line",
    },
    {
      id: "canby-post",
      name: "Canby Post Office",
      type: "USPS Passport Acceptance",
      address: "450 NW 1st Ave",
      city: "Canby",
      state: "OR",
      zip: "97013",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Canby — about 12 miles northeast via OR-99E",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Alternative acceptance facility for northeast Woodburn and Hubbard residents. Smaller facility with limited availability.",
      icon: "ri-mail-line",
    },
    {
      id: "wilsonville-post",
      name: "Wilsonville Post Office",
      type: "USPS Passport Acceptance",
      address: "29955 SW Boones Ferry Rd",
      city: "Wilsonville",
      state: "OR",
      zip: "97070",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Wilsonville — about 15 miles north via I-5",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Alternative for north Woodburn residents. Wilsonville has good availability compared to smaller offices. Conveniently located off I-5.",
      icon: "ri-mail-line",
    },
    {
      id: "silverton-post",
      name: "Silverton Post Office",
      type: "USPS Passport Acceptance",
      address: "400 S Water St",
      city: "Silverton",
      state: "OR",
      zip: "97381",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Silverton — about 15 miles southeast via Silverton Rd",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Alternative for east Woodburn and Mount Angel residents. Very limited appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport from Woodburn, Oregon?",
      a: "Yes. Fast Passport Center handles emergency passport processing for Woodburn residents as fast as 24 hours. The Seattle Passport Agency is about 4 hours from Woodburn — we serve you entirely remotely via overnight shipping. Start online, we handle the rest.",
    },
    {
      q: "How fast can I get an expedited passport from Woodburn, OR?",
      a: "Expedited passport processing from Woodburn takes 2–9 business days through Fast Passport Center. Most adult renewals don't require an in-person acceptance visit — ship overnight from Woodburn, Salem, or Wilsonville.",
    },
    {
      q: "Where is the passport acceptance office in Woodburn?",
      a: "Woodburn's primary passport acceptance is the Woodburn Post Office (1900 N Pacific Hwy). For better appointment availability, Salem Main Post Office (1050 25th St SE) and Marion County Clerk's Office (555 Court St NE) are recommended — about 15–16 miles south via I-5.",
    },
    {
      q: "Does Woodburn Premium Outlets generate international travel passport needs?",
      a: "Yes — Woodburn Premium Outlets is a major tourist destination drawing visitors from British Columbia, Washington, and across the Pacific Northwest. Many Woodburn residents work in the retail and hospitality industries serving these visitors and travel internationally for trade and buying trips. Additionally, Woodburn visitors from Canada sometimes discover passport issues while in town.",
    },
    {
      q: "How far is Woodburn from the Seattle Passport Agency?",
      a: "Woodburn is approximately 240 miles from the Seattle Passport Agency — about 4 hours by car via I-5. For life-or-death emergencies requiring same-day processing, a Seattle trip may be necessary. For most urgent travel needs, Fast Passport Center serves Woodburn entirely remotely.",
    },
    {
      q: "What airport do Woodburn residents use for international travel?",
      a: "Portland International Airport (PDX) is the primary international hub for Woodburn travelers — about 35 miles north via I-5 (approximately 35 minutes). PDX serves direct international routes to Amsterdam, London, Tokyo, Vancouver BC, and Mexico City. Woodburn's I-5 location makes PDX extremely accessible.",
    },
    {
      q: "Does Woodburn's agricultural industry create international passport demand?",
      a: "Yes — north Marion County is Oregon's richest agricultural region. Woodburn area farmers, nursery operators, and agricultural equipment professionals travel internationally to Europe (Germany, Netherlands, Italy), Asia (Japan, South Korea), and Canada for trade shows, equipment expos, and cooperative meetings throughout the year.",
    },
    {
      q: "Can I renew my passport from Woodburn without visiting an office?",
      a: "Yes. Most adult Woodburn residents renewing their passport can do so entirely by mail — no in-person acceptance visit required for renewals. Ship overnight from Woodburn, Wilsonville, or Salem, and we handle the Seattle agency submission.",
    },
    {
      q: "Can I get a child passport from Woodburn?",
      a: "Yes. Child passports require an in-person acceptance visit at the Woodburn Post Office, Salem Main Post Office, or Marion County Clerk's Office — both parents must typically be present or provide notarized consent. Fast Passport Center provides the child passport checklist and expedites after the acceptance step.",
    },
    {
      q: "How much does expedited passport processing cost from Woodburn?",
      a: "Fast Passport Center pricing includes the U.S. government passport fees plus our courier service fee — which is typically 30–100% lower than FedEx Office or retail passport services. We provide an exact price quote at checkout before any commitment.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Woodburn", address: "1570 Mount Hood Ave, Woodburn, OR 97071", hours: "Daily 8 AM – 10 PM" },
    { name: "Woodburn Post Office", address: "1900 N Pacific Hwy, Woodburn, OR 97071", hours: "Mon–Fri 9 AM – 5 PM" },
    { name: "Walgreens — Canby", address: "190 NW 2nd Ave, Canby, OR 97013", hours: "Daily 8 AM – 10 PM" },
    { name: "FedEx Office — Salem", address: "1101 Hawthorne Ave SE, Salem, OR 97301", hours: "Mon–Fri 7 AM – 10 PM, Sat–Sun 9 AM – 6 PM" },
    { name: "FedEx Office — Wilsonville", address: "25400 SW Parkway Center Dr, Suite 100, Wilsonville, OR 97070", hours: "Mon–Fri 7 AM – 10 PM, Sat 9 AM – 6 PM" },
    { name: "Walgreens — Keizer", address: "5017 River Rd N, Keizer, OR 97303", hours: "Daily 8 AM – 10 PM" },
    { name: "Costco Photo Center — Salem", address: "1010 Hawthorne Ave SE, Salem, OR 97301", hours: "Mon–Fri 10 AM – 8:30 PM, Sat–Sun 9:30 AM – 6 PM" },
    { name: "Walgreens — Salem South", address: "5650 Commercial St SE, Salem, OR 97306", hours: "Daily 8 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Woodburn Driver & Motor Vehicle Services",
      address: "690 N Pacific Hwy, Woodburn, OR 97071",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Woodburn DMV — driver licenses, REAL ID, and state ID cards for Woodburn and north Marion County residents.",
      featured: true,
    },
    {
      name: "Salem Driver & Motor Vehicle Services",
      address: "3809 Center St NE, Salem, OR 97301",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Salem DMV — full-service alternative for Woodburn residents. About 15 miles south via I-5.",
      featured: false,
    },
    {
      name: "Oregon City Driver & Motor Vehicle Services",
      address: "1924 Beavercreek Rd, Oregon City, OR 97045",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Oregon City DMV — alternative for north Woodburn residents. About 25 miles north via I-5 and I-205.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PDX",
      name: "Portland International Airport",
      distance: "Primary international hub — about 35 miles north via I-5 (approximately 35 minutes)",
      address: "7000 NE Airport Way, Portland, OR 97218",
      note: "Portland International Airport is the primary international departure hub for Woodburn and north Marion County travelers. PDX offers direct flights to Amsterdam, London, Reykjavik, Tokyo, Vancouver BC, and Mexico City — only 35 minutes from Woodburn.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Airport Website",
      featured: true,
    },
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "About 240 miles north via I-5 (approximately 4 hours)",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "SEA-TAC is an alternative major international hub with more flight options, especially for Asia and Alaska routes.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA-TAC Airport Website",
      featured: false,
    },
    {
      code: "SLE",
      name: "Salem Municipal Airport",
      distance: "About 15 miles south — limited regional service only",
      address: "2990 25th St SE, Salem, OR 97302",
      note: "Regional airport with minimal commercial service. Portland International (PDX) is strongly preferred for all Woodburn international travel.",
      flightUrl: "https://www.cityofsalem.net/airport",
      flightLabel: "SLE Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport — Woodburn & North Marion County",
      description: "Agricultural trade show in Germany next week? Family Mexico vacation departure approaching? Need a passport fast from Woodburn? Fast Passport Center handles emergency passport processing for Woodburn residents — as fast as 24 hours. Serve entirely remotely.",
      bullets: ["As fast as 24 hours processing", "Reserved Seattle agency submission", "Dedicated agent and live status tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Expedited Passport Renewal",
      description: "Passport expired and you have international travel coming up? Woodburn residents renew fast through Fast Passport Center — ship overnight from Woodburn, Wilsonville, or Salem, we handle the expedited submission.",
      bullets: ["Fastest renewal for north Marion County residents", "Ship overnight from Woodburn, Wilsonville, or Salem", "Professional document review included"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport in Woodburn or before an international business trip? We guide north Marion County travelers through DS-64 and expedited replacement — no Seattle trip required.",
      bullets: ["DS-64 theft/loss reporting guidance", "Expedited replacement timelines available", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport — Woodburn Families",
      description: "Woodburn families heading to Canada, Mexico, or European vacations need child passports. We guide you through the Woodburn Post Office or Salem acceptance step.",
      bullets: ["Both parents typically required to consent", "Woodburn Post Office or Salem facility guidance", "Expedited after in-person acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "First-Time Passport Applications",
      description: "First passport from Woodburn? In-person acceptance at the Woodburn Post Office or Marion County Clerk is required for first-timers. We guide you through every step and expedite from there.",
      bullets: ["Step-by-step acceptance guidance for Woodburn facilities", "Photo location guide for Woodburn and Salem area", "Expedited processing after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Registered State Dept. Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — not a reseller. We submit through reserved agency channels at 30–100% lower prices than retail services.",
      bullets: ["State Dept. registered courier", "Best price guarantee", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Specialty Passport Services",
      description: "Name change passports, damaged passport replacement, second passports for frequent travelers, and Woodburn and north Marion County residents with complex passport needs.",
      bullets: ["Name change after marriage", "Damaged passport replacement", "Second passport for frequent business travelers"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Same-day emergency passport processing for Woodburn, Oregon residents with urgent international travel needs." },
    { name: "Expedited Passport", description: "Expedited passport processing for Woodburn and north Marion County residents in 2–9 business days." },
    { name: "Passport Renewal", description: "Fast passport renewal for Woodburn, Oregon — ship overnight from Woodburn, Wilsonville, or Salem." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement for Woodburn travelers with lost or stolen passports." },
    { name: "Child Passport", description: "Expedited child passport services for Woodburn and Marion County families." },
    { name: "Passport Courier Service", description: "Registered U.S. Department of State courier serving Woodburn, Oregon and north Marion County." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Booking Mexico Winter Trips Without Checking Passport Validity", description: "Woodburn families love booking Mexico resort vacations for winter break. Many book months ahead but discover expired passports 2–4 weeks before departure during the holiday shopping season at the outlets." },
    { icon: "ri-camera-off-line", title: "Submitting Poor-Quality Passport Photos", description: "Photos from drugstores or self-taken phone photos frequently get rejected for lighting or expression issues. Fast Passport Center reviews photo specifications before submission." },
    { icon: "ri-file-damage-line", title: "Incomplete Forms or Missing Signatures", description: "One missing signature returns your application — costing weeks when you're on tight agricultural trade show timelines. Our pre-submission review catches all errors." },
    { icon: "ri-pen-nib-line", title: "Wrong Birth Certificate Format", description: "Short-form birth certificates are rejected. We specify exactly what document format is needed based on your state of birth." },
    { icon: "ri-plant-line", title: "Agricultural Equipment Expo Travel — Short Notice", description: "North Marion County agricultural professionals frequently get invited to equipment expos in Germany and Italy with 3–6 weeks notice. Maintain a current passport at all times if you work in agricultural exports or equipment sales." },
    { icon: "ri-car-line", title: "Assuming Canada Doesn't Require a Passport", description: "Many Woodburn residents assume Canada doesn't require a passport because it's 'just north.' For air travel to Canada, a valid passport IS required. Enhanced driver's licenses work only for land crossings." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Woodburn travel date. Complete your secure order from home in minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We send a personalized document checklist — exactly what to gather, with Woodburn and Marion County acceptance location guidance." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight", description: "Drop off at Woodburn, Wilsonville, or Salem FedEx Office for overnight delivery. All are reliable options for north Marion County residents." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Agency Access", description: "We submit through reserved Seattle Passport Agency slots — bypassing the public appointment backlog that stretches for weeks." },
    { number: "05", icon: "ri-passport-line", title: "Passport Shipped to Your Door", description: "Your completed passport ships directly to your Woodburn or north Marion County address. Live status tracking included." },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Must drive to Seattle — 4 hours from Woodburn via I-5",
        "Life-or-death emergencies only",
        "Very limited appointment availability",
        "Long wait times even with appointment",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Ship overnight from Woodburn, Wilsonville, or Salem",
        "Document review included",
        "Dedicated agent on your case",
        "Daily status updates",
        "Best price guarantee",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than USPS self-service",
        "Document review included",
        "Dedicated agent",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "Standard mail — no courier access",
        "6–13 weeks; can be longer in summer",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent",
        "Not suitable if travel is under 10 weeks away",
      ],
      highlight: false,
      muted: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — weeks-long wait, Seattle only", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Drive to Seattle — 4 hours from Woodburn", fpc: "Ship overnight from Woodburn, Wilsonville, or Salem" },
    { feature: "Processing Speed", agency: "Strict eligibility requirements", fpc: "As fast as 24 hours — multiple tiers" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "I-5 Corridor Accessibility", agency: "Not designed for small-city residents", fpc: "Fully remote service via overnight shipping" },
    { feature: "Government Shutdowns", agency: "May be impacted", fpc: "Not affected" },
    { feature: "Best Price Guarantee", agency: "Govt. fees + 8-hour Seattle round trip cost", fpc: "Best price guarantee — no travel required" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Salem", route: "/salem" },
    { name: "Emergency passport help in Keizer", route: "/keizer" },
    { name: "Fast passport renewal in Portland", route: "/portland" },
    { name: "Rush passport services for Oregon residents", route: "/oregon" },
    { name: "Expedited passports statewide in Oregon", route: "/oregon" },
  ],
  fpcOfficeNote: "After placing your order online, we send your personalized checklist and overnight shipping instructions. Ship from Woodburn, Wilsonville, or Salem — all located conveniently along the I-5 corridor. No visit to our processing facility required for most services.",
  fpcOfficeDistance: "Serving Woodburn, north Marion County, and the mid-Willamette Valley remotely",
  serviceAreaIntro: "Whether you are in Woodburn, Hubbard, Gervais, Donald, Aurora, St. Paul, or anywhere in north Marion County — Fast Passport Center makes emergency and expedited passport processing simple without a drive to Seattle.",
  nearbyCitiesIntro: "We serve all Woodburn and north Marion County zip codes and surrounding communities including Hubbard, Gervais, Donald, Aurora, St. Paul, Mount Angel, and Canby.",
  howItWorksIntro: "Getting an emergency or expedited passport from Woodburn is simpler than a 4-hour drive to Seattle. Most north Marion County clients never visit an office.",
  mistakesIntro: "These are the most common mistakes that cause delays for Woodburn and north Marion County passport applicants. We review your documents before submission to prevent all of them.",
  testimonialsIntro: "Real reviews from Woodburn, Hubbard, and north Marion County travelers who needed their passports fast.",
  faqIntro: "The most common questions Woodburn and north Marion County residents ask about emergency and expedited passport services.",
  statePageRoute: "/states/oregon",
  statePageName: "Oregon",
  travelTiming: {
    title: "Travel & Passport Timing for Woodburn and North Marion County Residents",
    intro: "Woodburn sits at the crossroads of Oregon's richest agricultural land and the I-5 corridor — home to fertile volcanic soil fields, the iconic Woodburn Premium Outlets, and a community deeply connected to the land and retail tourism. Its unique identity creates very specific international travel patterns for Woodburn and north Marion County residents.",
    cards: [
      {
        icon: "ri-plant-line",
        title: "Agricultural Industry International Travel",
        subtitle: "North Marion County's farmland economy drives global passport needs",
        description: "North Marion County is one of the world's most productive agricultural regions — growing nursery crops, grass seed, vegetables, berries, and specialty crops exported globally. Woodburn area farmers, nursery operators, and agricultural equipment professionals travel internationally to Germany (Agritechnica Hannover), Italy (EIMA Bologna), the Netherlands (horticulture trade), Japan (precision farming), and Canada (agricultural cooperatives) throughout the year.",
        tip: "Agricultural trade show dates are fixed annually. Mark your calendar 6 months before each major show to verify passport validity. Many European countries require 3+ months passport validity beyond your departure date.",
      },
      {
        icon: "ri-store-2-line",
        title: "Woodburn Premium Outlets — Retail & Tourism Crossroads",
        subtitle: "Oregon's largest outlet mall creates unique travel patterns",
        description: "Woodburn Premium Outlets is Oregon's largest outlet shopping destination, drawing visitors from Vancouver BC, Seattle, and across the Pacific Northwest. Many Woodburn residents work in retail, hospitality, and tourism — industries with international buying trips, trade shows, and cross-border connections. Additionally, Canadian outlet shoppers visiting Woodburn sometimes need emergency passport assistance while in town.",
        tip: "Retail and hospitality professionals in Woodburn traveling internationally for buying trips should maintain a passport with at least 12 months validity. Trade show invitations can arrive with as little as 4 weeks notice.",
      },
      {
        icon: "ri-sun-line",
        title: "Mexico Winter Sun — the I-5 Escape Route",
        subtitle: "Woodburn's direct I-5 access makes PDX and Mexico trips incredibly convenient",
        description: "Woodburn's I-5 location makes Portland International Airport only 35 minutes away — one of the shortest PDX commutes of any Oregon city. This makes Mexico resort vacations (Puerto Vallarta, Cabo, Cancun) incredibly popular with Woodburn families during the rainy winter months. Trips are typically booked in September–November for December–March travel, creating a predictable fall passport rush.",
        tip: "Woodburn families should check passport expiration in August, before the fall Mexico booking season begins. The 2–9 business day expedited window handles nearly all Mexico winter vacation timelines.",
      },
      {
        icon: "ri-car-line",
        title: "Canada Road Trips & BC Getaways",
        subtitle: "Vancouver BC is reachable in 4.5 hours from Woodburn via I-5",
        description: "Woodburn's I-5 corridor location makes British Columbia the most accessible international destination. Vancouver, Victoria, and Whistler are popular for summer vacations and winter ski weekends. Many Woodburn residents assume Canada doesn't need a passport for what feels like a regional trip — discovering the requirement at the last minute.",
        tip: "Canada requires a valid passport for air travel. For land crossings, enhanced driver's licenses (EDL) or passport cards are accepted. Verify your documents before booking any BC trip with flights or accommodations.",
      },
    ],
    callout: {
      icon: "ri-plant-line",
      title: "Woodburn, Oregon — Where Agriculture Meets the I-5 Corridor",
      description: "Woodburn sits at the intersection of world-class agricultural production, retail tourism, and the I-5 corridor. The city's unique identity — surrounded by some of the richest farmland in the Pacific Northwest, home to Oregon's largest outlet mall, and positioned perfectly on the I-5 between Portland and Salem — creates a distinctive set of international travel patterns. Fast Passport Center has served Woodburn and north Marion County residents with expedited passports for agricultural trade missions, retail buying trips, Mexico vacations, and Canada getaways.",
    },
  },
  destinations: {
    title: "Where Woodburn Travelers Go — And Why Passports Get Urgent",
    intro: "These are the destinations and travel patterns we see most from Woodburn and north Marion County clients. Agricultural trade shows, Mexico winter escapes, PDX convenience, and I-5 corridor Canada trips create unique passport urgency situations.",
    stats: [
      { stat: "240 mi", label: "to Seattle Passport Agency — the closest regional passport office from Woodburn" },
      { stat: "35 mi", label: "to Portland International Airport (PDX) — only 35 minutes via I-5" },
      { stat: "4.5 hrs", label: "to Vancouver BC — Woodburn's most popular Canadian destination" },
      { stat: "2–9", label: "business days for Fast Passport Center expedited processing from Woodburn" },
    ],
    destinations: [
      { name: "Germany — Hannover, Cologne, Düsseldorf", context: "Agricultural equipment trade shows (Agritechnica) draw Woodburn area professionals to Germany annually", urgency: "Fixed show dates with 6–8 weeks notice; business travelers need valid passport with 6+ months remaining", icon: "ri-plant-line" },
      { name: "Mexico — Puerto Vallarta, Cabo, Riviera Maya", context: "The #1 winter escape for Woodburn families — PDX is only 35 minutes from Woodburn via I-5", urgency: "September–November booking for December–March travel; passport expiration discovered 2–4 weeks before", icon: "ri-sun-cloudy-line" },
      { name: "Canada — Vancouver, Victoria, Whistler", context: "Woodburn's I-5 location makes BC the most accessible international destination — 4.5 hours driving", urgency: "Canada requires a passport for air travel; many book flights and discover the requirement last-minute", icon: "ri-map-pin-2-line" },
      { name: "Netherlands — Horticulture & Agricultural Trade", context: "Dutch greenhouse and horticultural technology draws Woodburn nursery professionals to the Netherlands", urgency: "Trade missions confirmed 6–10 weeks out; expedited processing handles these timelines comfortably", icon: "ri-plant-line" },
      { name: "Italy — Agricultural Machinery Expos", context: "EIMA Bologna agricultural machinery show is a destination for Woodburn equipment professionals", urgency: "November show dates; professionals confirm attendance in September–October — 4–6 weeks processing window", icon: "ri-store-2-line" },
      { name: "Japan & Asia — Export Market Travel", context: "Marion County agricultural exports (nursery stock, specialty crops) drive Japan and Korea business travel", urgency: "Trade delegations planned 2–3 months ahead; expedited processing serves these timelines", icon: "ri-ship-line" },
    ],
    crossLinksTitle: "Explore Nearby Oregon Service Areas",
    crossLinksDesc: "We serve travelers throughout the Willamette Valley and Mid-Valley region with the same expedited passport expertise.",
    crossLinks: [
      { name: "Salem", route: "/salem" },
      { name: "Keizer", route: "/keizer" },
      { name: "Portland", route: "/portland" },
    ],
  },
};